import React from "react";

const QuestionForm: React.FC<any> = () => {
  return (
    <div
      className='w-full h-60 text-20 text-[#333] font-normal flex mb-26 items-center justify-between gap-14 px-20 border-1 border-solid border-[#e8e8e8] rounded-8'
      style={{ background: "linear-gradient(90deg,#ffffff 50%, #f0f6ff)" }}
      onClick={() => {
        window.open(
          "https://docs.google.com/forms/d/e/1FAIpQLSfy-ULGdDHxehxfZ7WjCClxsT4WfDx61A8auK3If8Zdz3TnHw/viewform?usp=header",
          "_blank",
        );
      }}
    >
      <img src='https://photo.8891.com.tw/2025/02/17/1739787365481122.png' className='w-24 h-24' />
      <p className='flex-1'>
        對<span className='text-[#3264ff]'>購車菜單</span>滿意嗎？花<span className='text-[#3264ff]'>1分鐘</span>
        分享使用感受！
      </p>
      <img src='https://photo.8891.com.tw/2025/02/17/1739787912315075.png' className='w-8 h-14' />
    </div>
  );
};

export default QuestionForm;
